<template>
  <div class="d-inline">
    <v-form v-model="formValid">
      <v-select :label="$t('tipo_usuario') | capitalize" v-model="modeloLocal.tipo" :items="tipos" item-value="codigo"
                item-text="nombre" clearable prepend-inner-icon="mdi-account-details" :rules="[requerido]"/>
      <v-text-field :label="$t('label_usuario')" type="email" v-model="modeloLocal.usuario"
                    :disabled="!emailEditable" prepend-inner-icon="mdi-at"
                    :rules="emailEditable ? [email] : undefined" :hint="emailEditable ? $t('confirm_email'):undefined"/>
      <v-text-field :label="$t('label_nombre')" v-model="modeloLocal.nombre" :rules="[requerido, counter3]"
                    prepend-inner-icon="mdi-account"/>
      <v-text-field :label="$t('label_empresa')" v-model="modeloLocal.empresa"
                    :disabled="modeloLocal.tipo === 'no-profesional'"
                    :rules="modeloLocal.tipo !== 'no-profesional' ? [requerido]: []" prepend-inner-icon="mdi-domain"/>
      <v-text-field :label="$t('label_cargo')" v-model="modeloLocal.cargo"
                    :disabled="modeloLocal.tipo === 'no-profesional'"
                    :rules="modeloLocal.tipo !== 'no-profesional' ? [requerido]: []" prepend-inner-icon="mdi-tie"/>
    </v-form>
  </div>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";

export default {
  name: 'PerfilEditarComponent',
  components: {},
  model: {
    prop: 'valido',
    event: 'change'
  },
  props: {
    valido: {type: Boolean, required: true},
    perfil: {type: [Object], required: true},
    emailEditable: {type: Boolean, default: true}
  },
  data: () => ({
    formValid: false,
    modeloLocal: {
      usuario: "",
      nombre: "",
      empresa: "",
      cargo: "",
      tipo: null
    },
    tipos: []
  }),
  watch: {
    perfil: {
      handler(val) {
        if (!val) return;
        this.modeloLocal.usuario = val.usuario;
        this.modeloLocal.nombre = val.nombre;
        this.modeloLocal.empresa = this.modeloLocal.tipo && this.modeloLocal.tipo === "no-profesional" ? "" : val.empresa;
        this.modeloLocal.cargo = this.modeloLocal.tipo && this.modeloLocal.tipo === "no-profesional" ? "" : val.cargo;
        this.modeloLocal.tipo = val.tipo;
      }, deep: true
    },
    modeloLocal: {
      handler(val) {
        this.$emit('update:perfil', val);
      }, deep: true
    },
    formValid(val) {
      this.$emit("change", val);
    }
  },
  mounted() {
    this.cargarTiposUsuario();
  },
  methods: {
    requerido(value) {
      return !!value || this.$tc('requerido', 1)
    },
    counter3(value) {
      return value.length >= 3 || this.$t('minimo3')
    },
    email(value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || this.$t('req_email')
    },
    cargarTiposUsuario() {
      HttpHelper.get("auth/tipos-usuario").then((resp) => {
        this.tipos = resp;
      });
    }
  }

};
</script>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "label_usuario": "Correo electrónico",
    "label_nombre": "Nombre",
    "label_empresa": "Empresa",
    "label_cargo": "Cargo",
    "minimo3": "Mínimo 3 carácteres",
    "req_email": "Correo electrónico incorrecto",
    "confirm_email": "Es obligatorio introducir un correo electrónico válido para poder activar la cuenta",
    "tipo_usuario": "Tipo de usuario",
    "fabricante_ceramico": "Fabricante de baldosas cerámicas",
    "fabricante_no_ceramico": "Fabricante de otros materiales revestimiento",
    "distribuidor": "Distribuidor cerámico o multimaterial",
    "prescriptor": "Prescriptor (arquitecto, interiorista...)",
    "no_profesional": "Usuario no profesional"
  }
}
</i18n>
<!-- @formatter:on -->